import React from 'react';

const EditPencil = (props) => (
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.125 11.7812C2.25 11.3438 2.5 10.9375 2.8125 10.625L12.3125 1.125C13.0938 0.34375 14.375 0.34375 15.1562 1.125L16.375 2.34375C16.4688 2.4375 16.5625 2.5625 16.625 2.65625C17.1562 3.4375 17.0625 4.5 16.375 5.1875L6.875 14.6875C6.84375 14.7188 6.78125 14.75 6.75 14.8125C6.4375 15.0625 6.09375 15.25 5.71875 15.375L1.9375 16.4688C1.6875 16.5625 1.40625 16.5 1.21875 16.2812C1 16.0938 0.9375 15.8125 1 15.5625L2.125 11.7812ZM2.84375 14.6562L5.28125 13.9375C5.34375 13.9062 5.4375 13.875 5.5 13.8438L4.375 13.625C4.125 13.5625 3.90625 13.375 3.875 13.125L3.65625 12C3.625 12.0625 3.59375 12.1562 3.5625 12.2188L2.84375 14.6562ZM6.625 12.8125L12.9688 6.46875L11 4.53125L4.6875 10.875L5 12.4688L6.625 12.8125Z"
      fill="#667085"
    />
  </svg>
);
export default EditPencil;
